export var SUPPORT_MODAL_TYPES;
(function (SUPPORT_MODAL_TYPES) {
    SUPPORT_MODAL_TYPES["DEV_PLAN"] = "@contactSupportModal/devPlans";
})(SUPPORT_MODAL_TYPES || (SUPPORT_MODAL_TYPES = {}));
